import Button from "@qoohoo/common/components/library/Button";

function HeroSection({
  heading,
  theme,
  filler,
  headingAnnotationIcon,
  headingImage,
  description,
  buttonText,
  onButtonClick,
}) {
  return (
    <main className="flex flex-col items-center gap-6 md:gap-9 py-9 px-5 md:pt-[6.25rem] md:pb-20 relative">
      <div className="flex flex-col gap-6 items-center">
        <h1 className="font-bold text-[1.75rem] leading-normal md:text-5xl lg:text-7xl lg:leading-[5.25rem] text-center w-fit relative">
            {heading}
            <img
              src={headingImage}
              className="ml-2 lg:ml-3 h-7 md:h-12 lg:h-[4.5rem] inline-block"
            />
            {headingAnnotationIcon && <img src={headingAnnotationIcon} className="h-8 w-8 md:h-12 md:w-12 lg:h-[3.75rem] lg:w-[3.75rem] absolute top-0 right-0 -translate-y-1/3 translate-x-full"/>}
        </h1>
        <p className="text-base md:text-xl lg:text-2xl max-w-[16.875rem] md:max-w-[44.25rem] text-center">
            {description}
        </p>
      </div>
      <Button
        className="!h-9 md:!h-[3.25rem] !rounded text-[#ffffff] lg:mt-3 w-40 md:w-[17rem] text-sm md:text-lg"
        style={{ background: theme.accentColor }}
        onClick={onButtonClick}
      >
        {buttonText}
      </Button>
      {filler.iconLeft && (
        <img src={filler.iconLeft} className="h-5 w-5 md:h-12 md:w-12 absolute left-5 top-3 md:top-[4.5rem] md:left-32" />
      )}
      {filler.iconRight && (
        <img src={filler.iconRight} className="h-5 w-5 md:h-12 md:w-12 absolute bottom-20 right-5 md:bottom-32 md:right-36" />
      )}
    </main>
  );
}

export default HeroSection;
